import React, { createContext, useContext, useState } from 'react';

interface NavigationContextType {
  showNavigationWarning: boolean;
  pendingNavigation: string | null;
  setShowNavigationWarning: (show: boolean) => void;
  setPendingNavigation: (path: string | null) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showNavigationWarning, setShowNavigationWarning] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);

  return (
    <NavigationContext.Provider 
      value={{
        showNavigationWarning,
        pendingNavigation,
        setShowNavigationWarning,
        setPendingNavigation
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};